
import React from 'react';
import { Link } from 'react-router-dom';
import { User } from '@/models/user';
import { Button } from '@/components/ui/button';
import { BarChart3, Home, User as UserIcon, Settings, LogOut, Upload, Shield } from 'lucide-react';
import { Separator } from '@/components/ui/separator';

interface MobileNavLinksProps {
  user: User | null;
  onLinkClick: () => void;
  onLogout: () => void;
}

const MobileNavLinks: React.FC<MobileNavLinksProps> = ({ 
  user, 
  onLinkClick, 
  onLogout 
}) => {
  if (!user) {
    return (
      <div className="flex flex-col space-y-3">
        <Link to="/" onClick={onLinkClick} className="text-gray-900 font-medium">
          Home
        </Link>
        <Link to="/browse" onClick={onLinkClick} className="text-gray-900 font-medium">
          Browse Agents
        </Link>
        <Link to="/insights" onClick={onLinkClick} className="text-gray-900 font-medium">
          Insights
        </Link>
        <Link to="/about" onClick={onLinkClick} className="text-gray-900 font-medium">
          About
        </Link>
        <Separator className="my-2" />
        <Button 
          variant="default" 
          asChild
          className="w-full bg-purple-600 hover:bg-purple-700"
        >
          <Link to="/signup" onClick={onLinkClick}>Sign Up</Link>
        </Button>
        <Button 
          variant="outline" 
          asChild 
          className="w-full"
        >
          <Link to="/login" onClick={onLinkClick}>Sign In</Link>
        </Button>
      </div>
    );
  }

  return (
    <div className="flex flex-col space-y-3">
      <p className="text-sm text-gray-500 mb-1">Welcome, {user.name}</p>
      
      <Link to="/" onClick={onLinkClick} className="flex items-center text-gray-900">
        <Home className="mr-2 h-4 w-4" />
        <span>Home</span>
      </Link>
      
      <Link to="/dashboard" onClick={onLinkClick} className="flex items-center text-gray-900">
        <BarChart3 className="mr-2 h-4 w-4" />
        <span>Dashboard</span>
      </Link>
      
      <Link to="/profile" onClick={onLinkClick} className="flex items-center text-gray-900">
        <UserIcon className="mr-2 h-4 w-4" />
        <span>Profile</span>
      </Link>
      
      {user.isAdmin && (
        <Link to="/admin" onClick={onLinkClick} className="flex items-center text-blue-600 font-medium">
          <Shield className="mr-2 h-4 w-4" />
          <span>Admin Dashboard</span>
        </Link>
      )}
      
      {user.profileType === "creator" && (
        <Link to="/create-agent" onClick={onLinkClick} className="flex items-center text-gray-900">
          <Upload className="mr-2 h-4 w-4" />
          <span>Upload Agent</span>
        </Link>
      )}
      
      <Link to="/settings" onClick={onLinkClick} className="flex items-center text-gray-900">
        <Settings className="mr-2 h-4 w-4" />
        <span>Settings</span>
      </Link>
      
      <Separator className="my-2" />
      
      <Button 
        variant="destructive" 
        onClick={() => {
          onLogout();
          onLinkClick();
        }}
        className="w-full flex items-center justify-center"
      >
        <LogOut className="mr-2 h-4 w-4" />
        <span>Sign Out</span>
      </Button>
    </div>
  );
};

export default MobileNavLinks;
